import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { PublicContent } from '@/types/api';

const FALLBACK: PublicContent = { services: [], steps: [], settings: {} };

/**
 * Single source of truth for everything the public site renders.
 * Cached generously — this content changes at most a few times a month.
 */
export function usePublicContent() {
  const query = useQuery({
    queryKey: ['public-content'],
    queryFn: () => api.get<PublicContent>('/content'),
    staleTime: 10 * 60_000,
  });

  const data = query.data ?? FALLBACK;
  return { ...data, isLoading: query.isLoading, isError: query.isError };
}

/** Reads a setting with a sensible printed fallback. */
export const setting = (
  settings: Record<string, string>,
  key: string,
  fallback: string,
): string => settings[key]?.trim() || fallback;
